import { render } from "./RecoverLogin.vue?vue&type=template&id=1403eb80&scoped=true"
import script from "./RecoverLogin.vue?vue&type=script&lang=js"
export * from "./RecoverLogin.vue?vue&type=script&lang=js"

import "./RecoverLogin.vue?vue&type=style&index=0&id=1403eb80&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1403eb80"]])

export default __exports__